module.exports = __webpack_public_path__ + "img/smart.44e7187e.svg";